import sensors from 'sa-sdk-javascript';
import type { LocationInfo } from '@/utils';
import { SpinLoading } from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useQuery from '@/hooks/useQuery';
import { useCookies } from 'react-cookie';
import {
  cacheLocationForTiktok,
  channelInitSafeAreaCssVar,
  cacheCouponOrderNoForTiktok,
  cacheUserOpenIdForTiktok,
} from '@/channels';
import { HOME, MY_ADDRESS } from '@/constants/path';
import { updateAddressExtraInfo } from '@/store/addressSlice';

import './index.less';

interface TiktokLocationInfo extends LocationInfo {
  city: string;
  speed: number;
  accuracy: number;
  altitude: number;
  verticalAccuracy: number;
  horizontalAccuracy: number;
  errMsg: string;
}

interface TiktokLoginInfo {
  credential: string;
  meddyId: string;
  needVerify: boolean;
  newUser: boolean;
  newUserGift: boolean;
  openId: string;
  sid: string;
  unionId: string;
}
interface ScreenInfo {
  screenWidth: number;
  screenHeight: number;
  windowHeight: number;
  windowWidth: number;
  safeArea: {
    left: number;
    right: number;
    top: number;
    bottom: number;
    width: number;
    height: number;
  };
}
interface DecodeParams {
  redirectUrl?: string;
  distinctID?: string;
  locationInfo?: TiktokLocationInfo;
  loginInfo?: TiktokLoginInfo;
  screenInfo?: ScreenInfo;
  douyinCouponOrderNo?: string;
}

export type TransitPageQuery = {
  data?: string;
};

const TransitPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [, setCookie] = useCookies<string, { [key: string]: string }>(['sid']);

  const { data } = useQuery<TransitPageQuery>() as TransitPageQuery;

  useEffect(() => {
    let decodeParams;
    console.log('data', data);
    try {
      if (typeof data === 'string') {
        decodeParams = JSON.parse(decodeURIComponent(data)) as DecodeParams;
      }
    } catch (error) {
      console.log('Can not parse params');
    }
    console.log('decodeParams', decodeParams);

    // Init login info, location info here
    if (decodeParams) {
      const { loginInfo } = decodeParams;
      loginInfo?.sid && setCookie('sid', loginInfo.sid, { path: '/', maxAge: 60 * 60 * 24 * 365 });
      loginInfo?.meddyId && setCookie('meddyId', loginInfo.meddyId, { path: '/', maxAge: 60 * 60 * 24 * 365 });
      // trackUserLogin();

      cacheUserOpenIdForTiktok(loginInfo?.openId);
    }

    if (decodeParams?.locationInfo) {
      cacheLocationForTiktok(decodeParams.locationInfo);
    }
    if (decodeParams?.screenInfo) {
      channelInitSafeAreaCssVar(decodeParams.screenInfo);
    }
    if (decodeParams?.distinctID) {
      // 修改 H5 上报数据的 distinctID
      sensors.identify(decodeParams?.distinctID, true);
    }
    if (decodeParams?.douyinCouponOrderNo) {
      cacheCouponOrderNoForTiktok(decodeParams.douyinCouponOrderNo);
    }

    if (decodeParams?.redirectUrl === MY_ADDRESS) {
      dispatch(
        updateAddressExtraInfo({
          orderType: 2,
          enterFrom: `${HOME}?`,
          isMenu: true,
        }),
      );
    }

    history.pushState({}, '', HOME);

    // Finish init, leave page
    navigate(decodeParams?.redirectUrl || HOME);
  }, []);

  return (
    <div className="transit-page-container">
      <SpinLoading />
    </div>
  );
};

export default TransitPage;
